import { Component, OnInit, Input } from '@angular/core';
import { RequestHelper } from '@helper/request.helper';
import { BcaStorage } from '@storage/bca.storage';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { NavigationConstant } from '@constant/navigation.constant';
import { APIConstant } from '@constant/api.constant';
import { BcaRequestModel } from '@shared/data/BcaRequest.model';
import { MessageConstant } from '@constant/message.constant';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  response: any;
  vaNumber: any;
  companyCode: any;
  customerName: any;
  amount: any;
  currency: any;
  hostname: any = environment.hostName;
  isLoading = false;

  constructor(
    private apiService: RequestHelper,
    private storage: BcaStorage,
    private router: Router,
    private bcaModel: BcaRequestModel
  ) { }

  ngOnInit() {
    if (this.storage.data == null) {
      this.router.navigate([NavigationConstant.BCA_INQUIRY]);
    } else {
      const data = this.storage.data;

      this.response = data.inquiryStatus;
      this.customerName = data.customerName;
      this.amount = data.totalAmount;
      this.currency = data.currencyCode;
      this.vaNumber = data.vaNumber;
    }
  }

  goBack() {
    this.router.navigate([NavigationConstant.BCA_INQUIRY]);
  }

  submitPayment() {
    this.isLoading = true;
    if (this.amount == null || this.amount.toString().length > 15) {
      this.isLoading = false;
      this.openDialog(MessageConstant.PAYMENT_FAILED);
    } else {
      const dataInquiry = this.storage.data;
      this.bcaModel.companyCode = dataInquiry.companyCode;
      this.bcaModel.currencyCode = dataInquiry.currencyCode;
      this.bcaModel.customerName = dataInquiry.customerName;
      this.bcaModel.customerNumber = String(dataInquiry.vaNumber).substr(5);
      this.bcaModel.requestID = dataInquiry.requestID;
      this.bcaModel.subCompany = dataInquiry.subCompany;
      this.bcaModel.totalAmount = this.amount;
      this.bcaModel.vaNumber = dataInquiry.vaNumber;
      const requestPayment = this.bcaModel;

      this.apiService.post(environment.apiUrl + APIConstant.BCA_PAYMENT, JSON.stringify(requestPayment)).subscribe((data) => {
        data.vaNumber = this.vaNumber;
        this.storage.data = data;
        this.router.navigate([NavigationConstant.BCA_PAYMENT_RESULT])
      }, (err) => this.isLoading = false);
    }
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.BCA_INQUIRY);
  }

}
